<template>
  <div>
      <div class="col-md-12">
          <form class="form-horizontal">
              <div class="row">
                  <div class="panel panel-default">
                      <div class="panel-heading clearfix">
                          <h3 class="panel-title pull-left">
                              Editar
                          </h3>
                      </div>
                      <div class="panel-body">

                          <div class="container">
                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="title">Titulo <span class="text-danger">*</span></label></div>
                                  <div class="col-md-10">
                                      <input type="text" id="title" class="form-control" v-model="form.title" required>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="type">Tipo <span class="text-danger">*</span></label></div>
                                  <div class="col-md-10">
                                      <select id="type" class="form-control" v-model="form.type" required>
                                          <option value="">Selecione o tipo...</option>
                                          <option v-for="(type, index) in types" :value="index" :key="index">{{ type }}</option>
                                      </select>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="link_pt">Link (pt)</label></div>
                                  <div class="col-md-10">
                                      <input type="text" id="link_pt" class="form-control" v-model="form.link_pt" required>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="arquivo_pt">Arquivo (pt) <span class="text-danger">*</span></label></div>
                                  <div class="col-md-10">
                                      <div class="row" v-if="form.arquivo_pt">
                                          <div class="col-md-12">
                                              <img :src="form.arquivo_pt" width="500" height="auto"/>
                                          </div>
                                      </div>
                                      <br/>
                                      <div class="row">
                                          <div class="col-md-3">
                                              <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#modal-filemanager">Selecionar arquivo</button>
                                          </div>
                                          <div class="col-md-3">
                                              <button v-if="form.arquivo_pt" type="button" class="btn btn-danger" @click="removeFile">Remover</button>
                                          </div>
                                      </div>
                                      <br/>
                                      <div class="row">
                                          <div class="col-md-12">
                                              <p>
                                                  Formato de arte para o banner: tamanho total de <b>1920x464px</b> considerando palco útil de <b>1000x250px</b>, alinhado ao topo (o complemento da altura ficará sobreposto por elementos do site). Preferencialmente com peso abaixo de 300KB
                                              </p>
                                          </div>
                                      </div>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="arquivo_pt"></label></div>
                                  <div class="col-md-10">
                                      <span class="text-danger"><b>ATENÇÃO!!</b> Devido as diferentes resoluções de computadores, o preview pode não estar 100% fiel a realidade, use-o apenas como referência.</span>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="arquivo_pt">Preview</label></div>
                                  <div class="col-md-10">
                                      <div v-if="form.type == 'site' && form.arquivo_pt">
                                          <img :src="'/public/preview-banner/site/top-site.jpg'" width="500" height="auto"/>
                                          <br/>
                                          <img :src="form.arquivo_pt" width="500" height="auto"/>
                                          <br/>
                                          <img :src="'/public/preview-banner/site/bottom-site.jpg'" width="500" height="auto"/>
                                      </div>
                                      <div v-if="form.type == 'meus_pedidos' && form.arquivo_pt">
                                          <img :src="'/public/preview-banner/meus_pedidos/top-meus_pedidos.jpg'" width="500" height="auto"/>
                                          <br/>
                                          <img :src="form.arquivo_pt" width="500" height="auto"/>
                                          <br/>
                                          <img style="margin-top: -3.7em" :src="'/public/preview-banner/meus_pedidos/bottom-meus_pedidos.png'" width="500" height="auto"/>
                                      </div>
                                      <div v-if="form.type == 'portal' && form.arquivo_pt">
                                          <img :src="'/public/preview-banner/portal/top-portal.jpg'" width="500" height="auto"/>
                                          <br/>
                                          <img :src="form.arquivo_pt" width="500" height="auto"/>
                                          <br/>
                                          <img :src="'/public/preview-banner/portal/bottom-portal.jpg'" width="500" height="auto"/>
                                      </div>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="target">Abrir link em <span class="text-danger">*</span></label></div>
                                  <div class="col-md-10">
                                      <select id="target" class="form-control" v-model="form.target" required>
                                          <option value="">Selecione...</option>
                                          <option value="_self">Mesma janela...</option>
                                          <option value="_blank">Nova janela...</option>
                                      </select>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="active">Ativo <span class="text-danger">*</span></label></div>
                                  <div class="col-md-10">
                                      <select id="active" class="form-control" v-model="form.active" required>
                                          <option value="">Selecione...</option>
                                          <option value="1">Sim</option>
                                          <option value="0">Não</option>
                                      </select>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-12 text-center">
                                      <button class="btn btn-primary" type="button" @click="sendForm" v-if="this.id_banner">Atualizar</button>
                                      <button class="btn btn-primary" type="button" @click="sendForm" v-else>Salvar</button>
                                  </div>
                              </div>
                          </div>
                      </div>

                      <div class="text-right">
                      </div>
                  </div>
              </div>
          </form>
      </div>

      <file-manager @fileSelected="getFileSelected"></file-manager>
  </div>
</template>

<script>

import axios from "axios";
import Swal from 'sweetalert2';
import FileManager from '../../../components/c-atlas-filemanager.vue'

export default {
    name: 'BannerHome',
    components: { 'file-manager': FileManager },
    props: ['id_banner'],
    data() {
        return {
            form: {
                title: '',
                type: '',
                link_pt: '',
                arquivo_pt: '',
                target: '',
                active: ''
            },
            types: {
                site         : 'Site',
                portal       : 'Portal',
                meus_pedidos : 'Meus pedidos',
            }
        }    
    },
    beforeMount() {
        var _this = this;

        if (this.id_banner) {
            axios.get(_ROOT_PATH +'/admin/banners/buscar-cadastro/' + this.id_banner)
                .then(function (response) {
                    _this.form.title      = response.data.title;
                    _this.form.type       = response.data.type;
                    _this.form.link_pt    = response.data.link_pt;
                    _this.form.arquivo_pt = _PUBLIC_PATH + '/' + response.data.arquivo_pt;
                    _this.form.target     = response.data.target;
                    _this.form.active     = response.data.active;
                }).catch(function (error) {
                console.error(error);
            });
        }

    },
    methods: {
        sendForm () {
            var _this = this;
            if (!this.form.title || !this.form.type || !this.form.arquivo_pt || !this.form.target || !this.form.active) {
                Swal.fire({
                    title: 'Oops!',
                    text: 'Preencha todos os campos obrigatórios.',
                    type: 'error',
                    confirmButtonColor: '#d63030',
                    confirmButtonText: 'Ok!'
                });
            } else {
                if (this.id_banner) {
                    axios.post(_ROOT_PATH + '/admin/banners/atualizar/' + this.id_banner, this.form)
                        .then(function (response) {
                            if (response.data.status) {
                                Swal.fire({
                                    title: 'Sucesso!',
                                    text: 'Banner atualizado com sucesso!',
                                    type: 'success',
                                    confirmButtonColor: '#358f06',
                                    confirmButtonText: 'Obrigado!'
                                }).then((result) => {
                                    window.location.href = _ROOT_PATH + "/admin/banners/";
                                });
                            }
                        }).catch(function (error) {
                        Swal.fire({
                            title: 'Oops!',
                            text: 'Ocorreu um erro ao salvar o banner.',
                            type: 'error',
                            confirmButtonColor: '#d63030',
                            confirmButtonText: 'Ok!'
                        });
                        console.error(error);
                    });
                } else {
                    axios.post(_ROOT_PATH + '/admin/banners/salvar/', this.form)
                        .then(function (response) {
                            if (response.data.status) {
                                Swal.fire({
                                    title: 'Sucesso!',
                                    text: 'Banner salvo com sucesso!',
                                    type: 'success',
                                    confirmButtonColor: '#358f06',
                                    confirmButtonText: 'Obrigado!'
                                }).then((result) => {
                                    window.location.href = _ROOT_PATH + "/admin/banners/";
                                });
                            }
                        }).catch(function (error) {
                        Swal.fire({
                            title: 'Oops!',
                            text: 'Ocorreu um erro ao salvar o banner.',
                            type: 'error',
                            confirmButtonColor: '#d63030',
                            confirmButtonText: 'Ok!'
                        });
                        console.error(error);
                    });
                }
            }
        },
        getFileSelected (value) {
            this.form.arquivo_pt = value.url
            document.getElementById('close-modal').click();
        },
        removeFile () {
            this.form.arquivo_pt = '';
        }
    }
}
</script>

<style lang="scss" scoped>
</style>